<div class="app-layout">
  <ftr-header-logged-out />

  <main>
    <ng-content />
  </main>

  <ftr-footer />
</div>
